import { ParcelListActionTypes } from "parcel/screens/list/ParcelListActionTypes";
import { createActionCreator } from "common/ReduxUtils";

export const setParcelSelectedRows = createActionCreator(ParcelListActionTypes.SET_PARCEL_SELECTED_ROWS);
